import { VesselAlertsModelBase, VesselAlert, AlertId } from './vessel-alerts-model';

export class VesselAlertsModelImpl extends VesselAlertsModelBase {

    getAlerts(imo: number) {
        return this._imoToAlerts.get(imo) || [];
    }

    getAlert(imo: number, alertId: AlertId|string) {
        for (let alert of this.getAlerts(imo)) {
            if (alert.id === alertId) return alert;
        }

        return null;
    }

    addAlert(imo: number, alert: VesselAlert) {
        // Short-circuit if the alert already exists - we don't want to send an event in this case
        const existing = this.getAlert(imo, alert.id);
        if (existing && existing.message === alert.message) return;

        // Ensure an existing alert with the same ID is replaced
        const alerts = this.getAlerts(imo).filter(existingAlert => { return existingAlert.id !== alert.id; });
        alerts.push(alert);
        this._imoToAlerts.set(imo, alerts);
         if(alert.id.includes(AlertId.HeavyWeather) || alert.id?.includes(AlertId.ParametricRoll)){
            const weatherAlert: VesselAlert[] = []
            weatherAlert.push(alert)
            this._weatherAlert.push(alert);
            this.dispatchEvent(new CustomEvent(`alerts-changed`, {detail: {imo: imo,alerts: weatherAlert}}));
         }

         else {
            this.dispatchEvent(new CustomEvent(`alerts-changed`, {detail: {imo: imo, alerts}}));
         }
    }

    removeAlert(imo: number, alertId: AlertId) {
        const alerts = this.getAlerts(imo);
        const newAlerts = alerts.filter(existingAlert => { return existingAlert.id !== alertId; });
        if (alerts.length === newAlerts.length) return;

        this._imoToAlerts.set(imo, newAlerts);
        if(alertId.includes(AlertId.HeavyWeather) || alertId.includes(AlertId.ParametricRoll)){
            this._weatherAlert = this._weatherAlert.filter(existingAlert => { return existingAlert.id !== alertId; });
            this.dispatchEvent(new CustomEvent(`weather-alerts-changed`, {detail: {imo: imo, alerts: this._weatherAlert}}));
        }

        else {
            this.dispatchEvent(new CustomEvent(`alerts-changed`, {detail: {imo: imo, alerts: newAlerts}}));
        }  
    }

    clearAlerts(imo: number) {
        this._imoToAlerts.delete(imo);
        this.dispatchEvent(new CustomEvent(`alerts-changed`, {detail: {imo: imo, alerts: []}}));
    }

    private _imoToAlerts: Map<number,VesselAlert[]> = new Map();
    private _weatherAlert: VesselAlert[] = [];
}
